import { Patch } from 'utils/types'

import { Writeable } from '../../types'
import { ApiData, Entity, EntityId } from '../common'
import {
  NegativeOrganizationHeadquarters,
  OrganizationFoundedAt,
  OrganizationHeadquarters,
  OrganizationStages,
} from '../scoutingCampaignCriteria'
import { SearchFunctionType } from '../searchFunctions'

export type ScoutingCampaign = Entity & {
  readonly name: string
  readonly description: string
  readonly status: ScoutingCampaignStatus
  readonly editable: boolean
  readonly positiveKeywords: string
  readonly negativeKeywords: string
  readonly corporateId: EntityId
  readonly type?: SearchFunctionType
  readonly assignedOpsLeadId?: number
  readonly internalPositivePrimaryKeywordsSets?: string
  readonly internalPositiveSecondaryKeywords?: string
  readonly internalNegativePrimaryKeywords?: string
  readonly internalNegativeSecondaryKeywords?: string
  readonly internalCategories?: string
  readonly internalNegativeCategories?: string
  readonly internalLocations?: string
  readonly internalNegativeLocations?: string
  readonly internalStages?: string
  readonly internalMinimumYear?: number
  readonly internalMaximumYear?: number
  readonly internalIncludeCompaniesWithoutMaturityInformation: boolean
  readonly dailyCompanyLimit?: number
  readonly hoursBetweenBatchesOfPairings?: number
  readonly sampleCompanies?: string
  readonly sampleCompaniesText?: string[]
  readonly radarScouting: boolean
  readonly organizationHeadquarters?: OrganizationHeadquarters
  readonly negativeOrganizationHeadquarters?: NegativeOrganizationHeadquarters
  readonly organizationFoundedAt?: OrganizationFoundedAt
  readonly organizationStages?: OrganizationStages
  readonly relaxedSweetSpotDefinition?: string
  readonly includeCompaniesWithoutMaturityInformation: boolean
  readonly packageCountable: boolean
  readonly isDeleted: boolean
}

export enum ScoutingCampaignStatus {
  draft = 'draft',
  inactive = 'inactive',
  pendingValidation = 'pending validation',
  calibrationPhase = 'calibration phase',
  deliveryPhase = 'delivery phase',
  lsRunning = 'ls running',
  lsCompleted = 'ls completed',
  ddPendingValidation = 'dd pending validation',
  ddRunning = 'dd running',
  ddCompleted = 'dd completed',
}

export type ScoutingCampaignParams = Writeable<Partial<ScoutingCampaign>>
export type ApiScoutingCampaign = ScoutingCampaign
export type ApiScoutingCampaignData = ApiData<ApiScoutingCampaign>
export type ApiCreateScoutingCampaignData = ApiScoutingCampaignData & {
  readonly userId?: number
}
export type PatchScoutingCampaign = Patch<Omit<ScoutingCampaign, 'id' | 'createdAt' | 'updatedAt' | 'corporateId'>>
export const SCOUTING_CAMPAIGN_CACHE_STORE_ID = 'scouting-campaign'
